import moment from 'moment'

export interface TripSummary {
  days: number
  nights: number
}

export const calculateTripSummary = (
  startDate: Date | null,
  endDate: Date | null
): TripSummary | null => {
  if (!startDate || !endDate) {
    return null
  }

  const start = moment(startDate).startOf('day')
  const end = moment(endDate).startOf('day')

  const days = end.diff(start, 'days') + 1
  const nights = Math.max(0, days - 1)

  if (days <= 0) {
    return null
  }

  return { days, nights }
}

export const formatTripSummary = (summary: TripSummary): string => {
  const daysText = summary.days === 1 ? 'day' : 'days'
  const nightsText = summary.nights === 1 ? 'night' : 'nights'

  return `${summary.days} ${daysText} · ${summary.nights} ${nightsText}`
}
